import React from 'react';
import { CountryFlag } from 'project/country-flag';
import FavoritePlayerButton from 'components/favorite-player-button';
import {
    QUALIFY_RESERVE_FLAG,
    TEE_START_POSITION,
    CLUB_NAME,
    FQ_HOLE,
    RQ_HOLE,
    R1,
    R2,
    TOTAL,
    IN,
    SCORE,
    TODAY,
    QUALIFIED_STATUS
} from './qual-leaderboard-const';
import { renderQualifiedStatus, renderToPar } from './helpers/roundHelper';
import { getPlayerStatusSuffix } from './helpers/utils';

const QualLeaderboardPlayerRow = (props) => {
    const {
        renderField,
        player,
        renderPlayerPar,
        renderColorState,
        isFavorite,
    } = props;

    const favouriteTheme = {};
    if (isFavorite) {
        favouriteTheme.isWhite = true;
    } else {
        favouriteTheme.isDark = true;
    }

    return (
        <div
            className={`qual-leaderboard__row qual-leaderboard__row${isFavorite ? '--is-favorite' : ''}`}
            key={player.entryId}
        >
            <div className="qual-leaderboard__cell qual-leaderboard__cell--pos">
                <div
                    className="qual-leaderboard__content">{player.position ? player.position.text : '-'}</div>
            </div>

            <div className="qual-leaderboard__cell qual-leaderboard__cell--nationality">
                <div className="qual-leaderboard__content">
                    <CountryFlag
                        childCss={'qual-leaderboard__country-flag'}
                        image={player.countryFlagUrl}
                        title={player.countryName}
                    />
                </div>
            </div>

            <div className="qual-leaderboard__cell qual-leaderboard__cell--player">
                <div className="qual-leaderboard__cell--favorite">
                    <FavoritePlayerButton
                        playerId={player.entryId.toString()}
                        theme={favouriteTheme}
                    />
                </div>
                <div className="qual-leaderboard__content">
                    <div className="qual-leaderboard__player-info">
                        <div className="qual-leaderboard__player-name">
                            {player.lastName.toUpperCase()}, {player.firstName} {getPlayerStatusSuffix(player.playerStatus)}
                        </div>
                        <div className="qual-leaderboard__player-club">{player.clubName}</div>
                        <div
                            className="qual-leaderboard__player-qualified">{renderQualifiedStatus(player)}</div>
                    </div>
                </div>
            </div>
            {renderField(QUALIFY_RESERVE_FLAG, false, player)}
            {renderField(CLUB_NAME, false, player)}
            {renderField(TEE_START_POSITION, false, player)}
            {renderField(QUALIFIED_STATUS, false, player)}
            <div className="qual-leaderboard__cell qual-leaderboard__cell--par">
                <div className='qual-leaderboard__content'>
                    <div className={`qual-leaderboard__content-style ${renderColorState(player, 'par')}`}>
                        {renderToPar(player.toPar)}
                    </div>
                </div>
            </div>
            {renderPlayerPar(player)}
            {renderField(FQ_HOLE, false, player)}
            {renderField(R1, false, player)}
            {renderField(R2, false, player)}
            {renderField(TOTAL, false, player)}
            {renderField(RQ_HOLE, false, player)}
            {renderField(IN, false, player)}
            {renderField(SCORE, false, player)}
            {renderField(TODAY, false, player)}
        </div>
    );
};

export default QualLeaderboardPlayerRow;
